import * as React from 'react';
import {useEffect, useRef} from 'react';

interface Props {

}

const FeedWells : React.FC<Props> = props => {
    const didMountRef = useRef(false);

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    return <>
        <div className={"flex align-items-center grid"}>
            <div style={{fontSize: "3rem"}} className={"md:mr-4 sm:mr-0"}>
                <label style={{color: "#FF8000"}}>Feed</label>
                <label style={{color: "#39FF14"}}>Wells</label>
            </div>
            <label style={{fontWeight: 100, fontSize: "1.5rem"}}>Admin Console</label>
        </div>
    </>
};

export default FeedWells
